module.exports = __webpack_public_path__ + "img/dgjg2332_2.a85415b9.svg";